import React, { useCallback, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import $ from "jquery";
import Button from "@mui/material/Button";
import "./Message.scss";
import "./Home.scss";
import axios from "axios";
import MessageScreen from "./MessageScreen";
import { useNavigate, useLocation } from "react-router-dom";
import ChatDisplay from "./ChatDisplay";

import { useMediaQuery } from "react-responsive";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const AadiHome = () => {
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [AskQuestion, setAskQuestion] = useState("");
  const [errorData, setErrorData] = useState(false);
  const [isHistory, setisHistory] = useState(false);
  const [SessionStart, setSessionStart] = useState(true);
  const [isDefaultPage, setisDefaultPage] = useState(true);
  const [responceData, setResponceData] = useState([]);
  const [saveHistory, setSaveHistory] = useState(false);
  const chatWindowRef = useRef(null);
  const [Historyloading, setHistoryloading] = useState(false);
  const [SuccessHistoryloading, setSuccessHistoryloading] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const componentRef = useRef(null);
  const componentRef1 = useRef([]);
  const [viewMore, setViewMore] = useState(false);
  const [responseNum, setResponseNum] = useState(null);
  const [HistoySections, setHistoySections] = useState(true);
  const [historyFlag, setHistoryFlag] = useState(1);
  const [messageId, setMessageId] = useState(0);
  const [faqScreen, setFaqScreen] = useState(true);
  const [query, setQuery] = useState("");
  const [loadingIndex, setLoadingIndex] = useState(0);
  const [GenerateResponceID, setGenerateResponceID] = useState("");
  const inputRef = useRef(null);
  const messageListRef = useRef(null);
  const [divNumber, setDivNumber] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [historyResponse, setHistoryResponse] = useState([]);
  const [historyDataFlag, setHistoryDataFlag] = useState(false);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const baseurl = `https://aadiapi.azurewebsites.net/ask`;

  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  const handleSendClick = async () => {
    if (userInput === "") return false;
    setErrorData(false);
    setMessageId((prevState) => prevState + 1);

    setViewMore(true);

    setIsLoading(true);
    setFaqScreen(false);
    setQuery(userInput);

    setDivNumber((prevState) => prevState + 2);

    setResponceData((prevState) => [
      ...prevState,
      {
        query: userInput,
        user: true,
        loading: true,
        message_id: "",
        summary_of_summaries: "",
        content: "",
      },
    ]);
    if (responceData.length > 2) {
      setLoadingIndex((prevState) => prevState + 2);
    }

    const dataItem = { query: userInput };

    const source = axios.CancelToken.source();
    setCancelTokenSource(source);

    try {
      const response = await axios.post(baseurl, dataItem, {
        cancelToken: source.token,
      });
      const data = response.data;

      if (response.status === 200) {
        const botResponse = data.response;
        setResponceData((prevState) => [
          ...prevState,
          { ...botResponse, user: false },
        ]);
        setHistoryResponse((prevState) => [
          ...prevState,
          { response: botResponse },
        ]);
        setIsLoading(false);
        setTimeout(() => setSessionStart(false), 2000);
        setSaveHistory(true);
        setCancelTokenSource(null);
      } else {
        setIsLoading(false);
        setErrorData(true);
        setResponceData((prevState) => [
          ...prevState,
          { error: true, user: false },
        ]);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled", err.message);
      } else {
        setIsLoading(false);
        setErrorData(true);
        setResponceData((prevState) => [
          ...prevState,
          { error: true, user: false },
        ]);
        console.log("Error occurred", err);
      }
    }

    setUserInput("");
    setViewMore(false);
  };

  const handleCancelClick = () => {
    // if (cancelTokenSource !== null) {
    // }
    cancelTokenSource?.cancel("Request canceled by the user");
    setCancelTokenSource(null);
    console.log("Cancel token set to null");
  };

  useEffect(() => {
    return () => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Component unmounted");
      }
    };
  }, [cancelTokenSource]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!isLoading) {
      handleSendClick();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleFormSubmit(e);
    }
  };

  const handleExternalTextClick = (text) => {
    setUserInput(text);
    inputRef.current.focus();
  };

  const newChatStart = useCallback(() => {
    handleCancelClick();
    setisDefaultPage(false);
    setResponceData([]);
    setAskQuestion("");
    setisHistory(false);
    setHistoryloading(false);
    setSessionStart(true);
    setDivNumber(0);
    setResponseNum(0);
    setFaqScreen(true);
    setHistoryResponse([]);
    setUserInput("");
    setIsLoading(false);
    $(".bg-dark-card").removeClass("faqActive");
  }, []);

  useEffect(() => {
    if (divNumber > 2) {
      setTimeout(scrollToBottom, 200);
    }
  }, [divNumber]);

  useEffect(() => {
    if (isDefaultPage) {
      handleCancelClick();
    }
  }, [isDefaultPage]);

  const scrollToBottom = () => {
    let divId = "message-" + (divNumber - 2);
    let targetDiv = document.getElementById(divId);
    // console.log("Div Number: ", divId, targetDiv);

    if (targetDiv === null) {
      targetDiv = document.getElementById(divId);

      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth", // Smooth scroll
          block: "start", // Center the div vertically in the viewport
        });
      }
    } else {
      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth", // Smooth scroll
          block: "start", // Center the div vertically in the viewport
        });
      }
    }
  };



  const fetchHistoryDataItem = useCallback(async (responseID, summary, Id) => {
   

    // navigate(`/history?id=${responseID}`);
  }, []);

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);

    let paramsObject = {};
    if (Array.from(searchParams).length > 0) {
    
     
    } else {
    }
  }, []);

  const HistorySave = async () => {
    const baseUrl = `${process.env.REACT_APP_BASE_URL}//aadi/history2.0/data2.0`;
    const HistoryDataSave = [
      {
        responseID: GenerateResponceID || "",
        session: SessionStart,
        email: localStorage.getItem("userinfo"),
        data: historyResponse,
      },
    ];

    try {
      const response = await axios.post(baseUrl, HistoryDataSave);
      const data = response.data;
      setGenerateResponceID(data.response_id);
      if (response.status === 200) {
        setTimeout(() => {
          setSuccessHistoryloading(false);
        }, 2000);

        setHistoryDataFlag(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (saveHistory === true) {
      HistorySave();
      setTimeout(() => {
        setSaveHistory(false);
      }, 1000);
    }
  }, [saveHistory]);

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };
  window.addEventListener("resize", appHeight);
  useEffect(() => {
    appHeight();
  }, []);

  return (
    <div
      id="homePage"
      style={{ overflow: "hidden", height: "var(--app-height)" }}
      className={`${isDefaultPage ? "default-home-page" : ""}`}
    >
      <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
        <Box component="main" sx={{ flexGrow: 1, p: 1 }}>

          <div
            id="mainHome"
            style={{width:"100%"}}
          >
            <div
             
              style={{ width: "100%" }}
            >
              <div ref={chatWindowRef} id="statistic1">
                <div
                  className={isHistory ? "fullHeight" : ""}
                  id="statistic"
                  ref={messageListRef}
                >
                  {!faqScreen && (
                    <ChatDisplay
                      responceData={responceData}
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      query={query}
                      errorData={errorData}
                      loadingIndex={loadingIndex}
                      setResponceData={setResponceData}
                      isHistory={isHistory}
                      page="Home"
                    />
                  )}
                  {faqScreen && responceData && responceData.length === 0 && (
                    <>
                      <MessageScreen
                        handleExternalTextClick={handleExternalTextClick}
                        setUserInput={setUserInput}
                      />
                    </>
                  )}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"180px 1fr"}} className="col-12 inputTextboxHome">
                  <div
                    style={{
                      // display: "grid",
                      justifyContent: "flex-start",
                      justifyItems: "flex-start",
                    }}
                  >
                    {isTab ? (
                      <Button
                        variant="contained"
                        color="primary"
                        className="submit_btn"
                        onClick={newChatStart}
                        style={{
                            width:"98%",
                            height: "50px",
                          }}
                      >
                        <AddIcon style={{ height: "120%", width: "100%" }} />
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddIcon />}
                        style={{
                          width:"98%",
                          height: "50px",
                        }}
                        className="submit_btn"
                        onClick={newChatStart}
                      >
                        New Chat
                      </Button>
                    )}
                  </div>
                  <form onSubmit={handleFormSubmit} className="chat-form">
                    <div className="input-group mt-0 mb-0">
                      <input
                        ref={inputRef}
                        id="chat_pdf_input"
                        placeholder="Ask a question ..."
                        className="message-type-box form-control border-0"
                        type="text"
                        autoComplete="off"
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        onKeyDown={handleKeyPress}
                      />
                      <Button
                        id="send_pdf_chat"
                        className="btn btn-light-success text-success sendbtn borderColorNew"
                        onClick={handleSendClick}
                        disabled={isLoading}
                        type="submit"
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        ) : (
                          <SendIcon
                            style={{ color: "#0000a0" }}
                            className="colorCss"
                          />
                        )}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default AadiHome;
